import qs from 'qs'

// 定义通用的location接口，兼容原生Location和React Router Location
interface LocationLike {
  pathname: string
  search: string
  hash?: string
}

/**
 * 生成包含重定向参数的登录URL
 * @param customLocation 自定义location对象，如果不传则使用window.location
 * @returns 包含重定向参数的登录URL
 */
export function generateLoginUrlWithRedirect(customLocation?: LocationLike): string {
  const redirectUrl = getCurrentFullRoute(customLocation)
  const params = qs.stringify({ redirect: redirectUrl })
  
  console.log('记录重定向地址:', redirectUrl)
  console.log('生成登录URL参数:', params)
  
  return `/login?${params}`
}

/**
 * 获取当前完整路由字符串
 * @param customLocation 自定义location对象，如果不传则使用window.location
 * @returns 完整的路由字符串
 */
export function getCurrentFullRoute(customLocation?: LocationLike): string {
  const location = customLocation || window.location
  const { pathname, search, hash = '' } = location
  return `${pathname}${search}${hash}`
}

/**
 * 生成重定向参数对象
 * @param customLocation 自定义location对象，如果不传则使用window.location
 * @returns 包含redirect参数的对象
 */
export function generateRedirectParams(customLocation?: LocationLike): { redirect: string } {
  const redirectUrl = getCurrentFullRoute(customLocation)
  return { redirect: redirectUrl }
} 